module.exports = __webpack_public_path__ + "img/1956_uk.e0eb0331.svg";